import React from "react";
import OfficeMangerProfileContent from "../../Component/OfficeMangerProfile/OfficeMangerProfileContent";


function OfficeMangerProfile() {
  return <OfficeMangerProfileContent />
     
}

export default OfficeMangerProfile;
